/* eslint-disable */ import { memoEval, sceneEntityObjectPropertiesComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const topRectangleComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'body', true).withEntity('TopRectangle').attach(memoEval((self)=>[
            self.$objectName
        ], ($objectName)=>({
            fileUrl: '/models/algu3d.glb',
            objectName: $objectName,
            dimensionUnit: 'm'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'body', true).withEntity('TopRectangle').attach(memoEval((self)=>[
            self.length,
            self.width,
            self.thickness,
            self.$edgeFinishFacet,
            self.$edgeFinishRound
        ], (length, width, thickness, $edgeFinishFacet, $edgeFinishRound)=>({
            morphTargetInfluences: {
                Length: {
                    value: length,
                    scaleOne: 3000,
                    scaleZero: 1600
                },
                Width: {
                    value: width,
                    scaleOne: 1300,
                    scaleZero: 800
                },
                Depth: {
                    value: thickness,
                    scaleOne: 60,
                    scaleZero: 12
                },
                Facet: {
                    value: $edgeFinishFacet,
                    scaleOne: 1,
                    scaleZero: 0
                },
                Bol: {
                    value: $edgeFinishRound,
                    scaleOne: 1,
                    scaleZero: 0
                },
                Boomstamrand: {
                    value: 0,
                    scaleOne: 1,
                    scaleZero: 0
                },
                Radius_40mm: {
                    value: 0,
                    scaleOne: 1,
                    scaleZero: 0
                },
                Radius_100mm: {
                    value: 0,
                    scaleOne: 1,
                    scaleZero: 0
                }
            }
        })))
];

//# sourceMappingURL=top-rectangle.js.map